import { G as i } from "../../../../GradientSelector.utils-DUau0PhO.js";
import { useCallback as s } from "react";
import { b as t, R as e } from "../../../../dummyModel-DGc8qBEQ.js";
const b = (o) => s((r) => {
  if (Object.keys(r)[0] === "type")
    switch (Object.values(r)[0]) {
      case t.interval:
        return o({
          ...r,
          color: void 0,
          gradient: void 0,
          interval: {
            secondColor: e["red-border"],
            firstColor: e["green-border"],
            step: 1e3
          }
        });
      case t.fixed:
        return o({
          ...r,
          gradient: void 0,
          interval: void 0,
          color: e["blue-border"]
        });
      case t.gradient:
        return o({
          ...r,
          color: void 0,
          interval: void 0,
          gradient: {
            base: e["red-border"],
            type: i.greenToRed
          }
        });
      case null:
        return o({
          ...r,
          color: void 0,
          interval: void 0,
          gradient: void 0
        });
      default:
        return o(r);
    }
  else
    return o(r);
}, [o]);
export {
  b as useOnValuesChanges
};
//# sourceMappingURL=MetricDisplayOptionSelector.hooks.js.map
